/**
 * A sidebar sai deste array, filtrado por modulo instalado e permissao.
 * So menus principais, na ordem do dia da escola: reabordar, acompanhar,
 * matricular, contratar. Os submenus de cada secao viram ABAS dentro da
 * pagina, nunca itens de sidebar.
 */
import type { Chave } from '../i18n/index.tsx';

export type ItemMenu = {
  readonly id: string;
  readonly rotulo: Chave;
  readonly rota: string;
  readonly icone: string;
  /** o menu aparece se pelo menos um destes modulos estiver instalado */
  readonly modulos: readonly string[] | 'sempre';
  /** se houver, o item so aparece para quem tem a permissao (o servidor confere de novo) */
  readonly permissao?: string;
};

export const MENU: readonly ItemMenu[] = [
  { id: 'inicio',        rotulo: 'menu.inicio',        rota: '/',              icone: 'LayoutDashboard', modulos: 'sempre' },
  { id: 'leads',         rotulo: 'menu.leads',         rota: '/leads',         icone: 'Target',          modulos: ['leads'] },
  { id: 'comercial',     rotulo: 'menu.comercial',     rota: '/comercial',     icone: 'ListChecks',      modulos: ['comercial'] },
  { id: 'turmas',        rotulo: 'menu.turmas',        rota: '/turmas',        icone: 'GraduationCap',   modulos: ['turmas'] },
  { id: 'pessoas',       rotulo: 'menu.pessoas',       rota: '/pessoas',       icone: 'IdCard',          modulos: ['pessoas'] },
  { id: 'contratos',     rotulo: 'menu.contratos',     rota: '/contratos',     icone: 'FilePen',         modulos: ['contratos'], permissao: 'contratos.ver' },
  { id: 'integracoes',   rotulo: 'menu.integracoes',   rota: '/integracoes',   icone: 'Plug',            modulos: ['integracoes'] },
  { id: 'configuracoes', rotulo: 'menu.configuracoes', rota: '/configuracoes', icone: 'Settings',        modulos: ['configuracoes'] },
  { id: 'admin',         rotulo: 'menu.admin',         rota: '/admin',         icone: 'Shield',          modulos: ['admin'] },
];

export const menuVisivel = (
  instalados: readonly string[], permissoes: readonly string[] = [],
): readonly ItemMenu[] =>
  MENU.filter((i) => i.modulos === 'sempre' || i.modulos.some((m) => instalados.includes(m)))
    .filter((i) => i.permissao === undefined || permissoes.includes(i.permissao));
